import React, { Component } from 'react';
import * as Sentry from '@sentry/browser';

type Props = {
  children: React.ReactNode;
};

class SentryErrorBoundary extends Component<Props> {
  componentDidCatch(error: Error): void {
    Sentry.captureException(error);
  }

  render(): React.ReactNode {
    return this.props.children;
  }
}

export default SentryErrorBoundary;
